import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  signal,
} from '@angular/core';

export type UiMessageVariant = 'error' | 'warning' | 'success' | 'info';

/**
 * Átomo: mensaje contextual presentacional. Sin lógica de negocio ni HTTP.
 * Soporta proyección de acciones (botones) mediante ng-content select="[actions]".
 */
@Component({
  selector: 'ui-message',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './message.component.html',
  styleUrl: './message.component.scss',
})
export class UiMessageComponent {
  /** Variante visual y semántica */
  readonly variant = input<UiMessageVariant>('info');

  /** Título en negrita (opcional) */
  readonly title = input('');

  /** Mensaje de texto plano (opcional; puede usarse ng-content en su lugar) */
  readonly message = input('');

  /** Muestra botón de cierre */
  readonly closable = input(false);

  /** Elimina el margen inferior */
  readonly noMarginBottom = input(false);

  /** Emite cuando el usuario presiona el botón de cierre */
  readonly closed = output<void>();

  /** Estado de visibilidad interno — se oculta al cerrar */
  protected readonly visible = signal(true);

  protected onClose(): void {
    this.visible.set(false);
    this.closed.emit();
  }

  protected readonly iconPath = computed(() => {
    switch (this.variant()) {
      case 'error':
        return 'M12 9v4m0 4h.01M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z';
      case 'warning':
        return 'M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0zM12 9v4m0 4h.01';
      case 'success':
        return 'M22 11.08V12a10 10 0 1 1-5.93-9.14M22 4 12 14.01l-3-3';
      case 'info':
      default:
        return 'M12 16v-4m0-4h.01M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z';
    }
  });

  protected readonly ariaRole = computed(() =>
    this.variant() === 'error' || this.variant() === 'warning' ? 'alert' : 'status',
  );
}
